import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Document } from '../../../../models/document.model';

import { CommonModule } from '@angular/common';
import { DragAndDropComponent } from '../drag-and-drop/drag-and-drop.component';

import { DocumentCaptureFooterComponent } from '../document-capture-footer/document-capture-footer.component';

@Component({
    selector: 'app-generic-document-capture',
    templateUrl: './generic-document-capture.component.html',
    styleUrl: './generic-document-capture.component.scss',
    standalone: true,
    imports: [CommonModule, DragAndDropComponent, DocumentCaptureFooterComponent]
})
export class GenericDocumentCaptureComponent {
  @Input() fileTitle?: string;
  @Input() instructions?: string[];
  @Input() document?: Document;
  @Input() enableSubmitButton?: boolean;
  @Input() enableUploadButton?: boolean;

  @Input() allowMultipleFiles: boolean = true;

  @Output() onFileUploaded = new EventEmitter();
  @Output() onCleaned = new EventEmitter();
  @Output() onSubmitted = new EventEmitter();

  get displayInstructions(): string[] | undefined {
    return this.instructions || this.document?.instructions;
  }

  get isUploadButtonEnabled(): boolean {
    return this.enableUploadButton ?? this.document?.enableUploadButton ?? false;
  }

  get isSubmitButtonEnabled(): boolean {
    return this.enableSubmitButton ?? this.document?.enableSubmitButton ?? false;
  }

  onUploadDocument(event: any) {
    if (this.document) {
      this.document.files = event.documentUploadedList || event;
      this.document.enableSubmitButton = this.document.files.length > 0;
    }
    this.onFileUploaded.emit(this.document || event);
  }

  onCleanDocument(event: any) {
    if (this.document) {
      this.document.files = event.documentUploadedList || event;
      this.document.enableSubmitButton = this.document.files.length > 0;
    }
    this.onCleaned.emit(this.document || event);
  }

  onSubmit(event: any) {
    this.onSubmitted.emit(this.document || event);
  }
}
